import { navigateTo, navigateToPath } from "../../routing";
import PATHS from "../../constants/routePaths";
import { NavigationType } from "../../stores/session";
import { settingsStore } from "../../stores/settings";
import { addressesStore } from "../../stores/addresses";
import { get } from "svelte/store";

export interface SkillTest {
  question: string;
  answer: string | number;
  countries: string[]
}

export const checkIfStepShouldBeRendered = () => {
  const skillTestConfig = get(settingsStore).skillTest as SkillTest;
  const selectedAddress = get(addressesStore).addresses.find((address) => {
    return address.is_default;
  });

  if (skillTestConfig.countries.includes("world")) {
    return;
  }

  if (!selectedAddress) {
    return;
  }

  if (skillTestConfig.countries.includes(selectedAddress?.country?.toLowerCase())) {
    return;
  }

  navigateTo(NavigationType.Next);
};

export const continueHandler = (answer: string) => {
  const skillTestConfig = get(settingsStore).skillTest as SkillTest;
  if (String(skillTestConfig.answer) === answer) {
    navigateTo(NavigationType.Next);
  } else {
    navigateToPath(PATHS.UNLUCKY);
  }
};
